module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("HE04K"))).then(() => parcelRequire('5erN3'));